<template>
  <v-card
    class="section-card"
    :class="{ 'section-card--highlight': highlight, 'mt-4': !highlight && spaced }"
    elevation="0"
    dark
  >
    <v-card-title class="section-header">
      <v-icon small class="mr-2 section-header-icon">{{ icon }}</v-icon>
      <slot name="title">{{ title }}</slot>
    </v-card-title>
    <v-card-text>
      <slot />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'FormSectionCard',
  props: {
    title: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      required: true
    },
    highlight: {
      type: Boolean,
      default: false
    },
    spaced: {
      type: Boolean,
      default: true
    }
  }
};
</script>
